<template>
  <div :class="['editor-detail-card-skeleton', { _mobile: isMobile }]">
    <div class="editor-detail-card-skeleton__top">
      <div class="editor-detail-card-skeleton__avatar"></div>
      <ul v-if="isMobile" class="editor-detail-card-skeleton__contacts">
        <li
          v-for="index in 3"
          :key="index"
          class="editor-detail-card-skeleton__contact"
        ></li>
      </ul>
    </div>
    <div class="editor-detail-card-skeleton__info">
      <div class="editor-detail-card-skeleton__heading">
        <div class="editor-detail-card-skeleton__name"></div>
        <div class="editor-detail-card-skeleton__job-title"></div>
      </div>
      <div class="editor-detail-card-skeleton__description"></div>
      <div class="editor-detail-card-skeleton__topics">
        <div
          v-for="index in 4"
          :key="index"
          class="editor-detail-card-skeleton__topic"
        ></div>
      </div>
      <div v-if="!isMobile" class="editor-detail-card-skeleton__footer">
        <div class="editor-detail-card-skeleton__contacts">
          <div
            v-for="index in 3"
            :key="index"
            class="editor-detail-card-skeleton__contact"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const isMobile: boolean = useIsMobile();
</script>

<style lang="less">
.editor-detail-card-skeleton {
  .box-shadow();

  display: flex;
  gap: @size-x9;
  align-items: flex-start;
  border-radius: @main-size;
  padding: @size-x8;

  &__top {
    flex-shrink: 0;
  }

  &__avatar {
    .skeleton(140px, 140px);

    flex-shrink: 0;
  }

  &__info {
    .flex-column(@size-x4);

    flex: 1 1 auto;
    min-width: 0;
  }

  &__heading {
    .flex-column(@main-size);
  }

  &__name {
    .skeleton(50%, 31px);
  }

  &__job-title {
    .skeleton(30%, 18px);
  }

  &__description {
    .skeleton(100%, 42px);
  }

  &__topics {
    display: flex;
    flex-wrap: wrap;
    gap: @main-size;
  }

  &__topic {
    .skeleton(120px, 26px);
  }

  &__footer {
    display: flex;
    align-items: center;
    margin-top: @size-x3;
  }

  &__contacts {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: @size-x6;
  }

  &__contact {
    .skeleton(90px, 19px);
  }

  &._mobile {
    flex-direction: column;
    gap: @size-x5;
    padding: @size-x4;
  }

  &._mobile &__top {
    display: flex;
    gap: @size-x6;
  }

  &._mobile &__avatar {
    width: 120px;
    height: 120px;
  }

  &._mobile &__contacts {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
